module.exports = __webpack_public_path__ + "static/media/logo.b15a7c98.png";